import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME } from './reducer';
import { I18n } from 'react-redux-i18n';
import PopupWarning from '../../../common/popup-portal/popup-warning/PopupWarning';

class CanslimPopup extends React.Component {
  render() {
    const { parentRef = {}, canSlimData, isLoading } = this.props;
    let isShowPopup = false;

    if (!canSlimData.length && !isLoading) {
      isShowPopup = true;
    }

    if (!isShowPopup) return null;
    return (
      <PopupWarning
        text={I18n.t('stRanking.popup.warning.title')}
        isShow={isShowPopup}
        onOverlayClicked={true}
        textContent={I18n.t('stRanking.popup.warning.content')}
        parentRef={parentRef ? parentRef.current : null}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    canSlimData: state[REDUCER_NAME].canSlimData,
    isLoading: state[REDUCER_NAME].isLoading,
    idHover: state[REDUCER_NAME].idHover,
  };
};

export default connect(mapStateToProps)(CanslimPopup);
